import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getStoryCheer = (storyId) => API.get(`/stories/${storyId}/cheer-info/`);

const getStoryCheers = (storyId, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/stories/${storyId}/cheers/?${params}`);
};

const getStoryCheersRankings = (storyId, page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/stories/${storyId}/cheerer-ranking/?${params}`);
};

const donateStory = (
  targetUserId,
  storyId,
  balloon,
  message,
  episodeId = null,
  voucherId = null
) => {
  if (message) {
    return API.post(`/donations/`, {
      targetUserId,
      balloon,
      message,
      storyId,
      ...(episodeId ? { episodeId } : {}),
      ...(voucherId ? { voucherId } : {}),
    });
  }

  return API.post(`/donations/`, {
    targetUserId,
    balloon,
    storyId,
    ...(episodeId ? { episodeId } : {}),
  });
};

const cheerStory = (storyId, type) =>
  API.post(`/stories/${storyId}/cheers/`, { type });

const getEpisodeDonationRankiongs = (
  storyId,
  episodeId,
  page = 1,
  perPage = 3
) => {
  const params = toParams({ page, perPage });
  return API.get(
    `/stories/${storyId}/episodes/${episodeId}/donation-ranking/?${params}`
  );
};

export default {
  getStoryCheer,
  getStoryCheers,
  getStoryCheersRankings,
  donateStory,
  cheerStory,
  getEpisodeDonationRankiongs,
};



// WEBPACK FOOTER //
// ./src/app/apis/donation.js